import PropTypes from 'prop-types';

import { SeoButton, ALWAYS_LINKABLE_BUTTON } from 'dibs-seo/exports/SeoButton';

import styles from './ContemporaryLandingHeaderModule.scss';

export const ContemporaryLandingHeaderModule = ({
    cta,
    imagePath,
    linkData,
    subtitle,
    title,
    onClick = () => {},
}) => {
    return (
        <div className={styles.wrapper}>
            <div>
                {imagePath ? (
                    <img className={styles.image} src={imagePath} alt={title} />
                ) : (
                    <div className={styles.placeholder} />
                )}
            </div>
            <div className={styles.moduleWrapper}>
                <div className={styles.module}>
                    <div className={styles.title}>{title}</div>
                    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    <SeoButton
                        variant={ALWAYS_LINKABLE_BUTTON}
                        linkData={linkData}
                        className={styles.button}
                        size="medium"
                        onClick={onClick}
                    >
                        {cta}
                    </SeoButton>
                </div>
            </div>
        </div>
    );
};

ContemporaryLandingHeaderModule.propTypes = {
    onClick: PropTypes.func,
    cta: PropTypes.string.isRequired,
    imagePath: PropTypes.string,
    linkData: PropTypes.object.isRequired,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
};
